import {pageInfo,exportData,detail,download,batchDownload,bankDetail,updateBankSubmit, noticeAfreshBindSubmit} from './../api';
import {goodsCategory, plant} from '../../../../../api'
import {Message} from 'element-ui';

const collection = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    goodsCategoryObj: null,
    plantObj: null,
    exportDataObj: null,
    downloadObjObj: null,
    batchDownloadObj: null,
    bankDetailObj: null,
    updateBankSubmitObj: null,
    noticeAfreshBindSubmitObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true, item.collectionStatus == 0 ? true : false,true,true]}));

    },
    GOODS_CATEGORY(state, data) {
      state.goodsCategoryObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportDataObj = data;
    },
    DETAIL(state,data){
      state.detailObj = data;
    },
    DOWNLOAD(state,data){
      state.downloadObj = data;
    },
    BATCH_DOWNLOAD(state,data){
      state.batchDownloadObj = data;
    },
    BANK_DETAIL(state,data){
      state.bankDetailObj = data;
    },
    UPDATE_BANK_SUBMIT(state, data){
      state.updateBankSubmitObj = data;
    },
    NOTICE_ADRESH_BIND_SUBMIT(state, data){
      state.noticeAfreshBindSubmitObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async goodsCategory({commit}, obj) {
      let resp = await goodsCategory(obj);
      commit('GOODS_CATEGORY', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async detail({commit}, obj){
      let resp = await detail(obj);
      commit('DETAIL', resp);
    },
    async download({commit}, obj){
      let resp = await download(obj);
      commit('DOWNLOAD', resp);
    },
    async batchDownload({commit}, obj){
      let resp = await batchDownload(obj);
      commit('BATCH_DOWNLOAD', resp);
    },
    async bankDetail({commit}, obj){
      let resp = await bankDetail(obj);
      commit('BANK_DETAIL', resp);
    },
    async updateBankSubmit({commit}, obj){
      let resp = await updateBankSubmit(obj);
      commit('UPDATE_BANK_SUBMIT', resp);
    },
    async noticeAfreshBindSubmit({commit}, obj){
      let resp = await noticeAfreshBindSubmit(obj);
      commit('NOTICE_ADRESH_BIND_SUBMIT', resp);
    },

  }
}
export default collection



// WEBPACK FOOTER //
// ./src/page/bd/run/collection/store/collection.store.js